/** Where the other apps live. Defaults suit a single host; override for split deployments. */
export const DASHBOARD_URL = import.meta.env.VITE_DASHBOARD_URL || "/parent/";
export const PORTAL_URL = import.meta.env.VITE_PORTAL_URL || "/wall/";
/** "Write to us" links only appear when a support address is configured. */
export const SUPPORT_EMAIL: string = import.meta.env.VITE_SUPPORT_EMAIL || "";

export const SIGN_UP_URL = DASHBOARD_URL + "#sign-up";
export const SIGN_IN_URL = DASHBOARD_URL + "#sign-in";

/** Pages of the public site. Unknown paths fall back to the home page. */
export const ROUTES = {
  home: "/",
  pricing: "/pricing",
  privacy: "/privacy",
  faq: "/faq",
} as const;
export type Route = keyof typeof ROUTES;

/** Anchors on the home page; every other hash on "/" is a legacy parent-app link. */
export const HOME_ANCHORS = ["how-it-works", "wall-app", "coaching"];
